var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-time-picker',{staticClass:"w-full",attrs:{"has-time":_vm.hasTime,"min-datetime":null},model:{value:(_vm.answer),callback:function ($$v) {_vm.answer=$$v},expression:"answer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }